var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppealAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0fc14a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 41.18,
    width: 6,
    height: 14.82
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11,
    y: 26.34,
    width: 6,
    height: 29.66
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22,
    y: 16.45,
    width: 6,
    height: 39.55
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33,
    y: 30.42,
    width: 6,
    height: 25.58
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44,
    y: 6.16,
    width: 6,
    height: 49.84
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55,
    y: 19.42,
    width: 6,
    height: 36.58
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 66,
    width: 6,
    height: 56
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77,
    y: 13.95,
    width: 6,
    height: 42.05
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88,
    y: 22.58,
    width: 6,
    height: 33.42
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99,
    y: 36.8,
    width: 6,
    height: 19.2
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110,
    y: 28.54,
    width: 6,
    height: 27.46
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 121,
    y: 7.15,
    width: 6,
    height: 48.85
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 132,
    y: 22.58,
    width: 6,
    height: 33.42
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 143,
    y: 33.36,
    width: 6,
    height: 22.64
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 154,
    y: 12.1,
    width: 6,
    height: 43.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppealAll);
export default __webpack_public_path__ + "static/media/appealAll.a72ead8f.svg";
export { ForwardRef as ReactComponent };